import React from "react";
import { useTranslation } from "react-i18next";
import cardData from "./cardData.json";
import "./ShopifyContent.css";
import shopifyLogo from "../../Images/Owision/logos_shopify.png";
import stripeLogo from "../../Images/Owision/logos_stripe.png";
import mirrorImg from "../../Images/Owision/mondaymirror.png";

const AppCard = ({ app }) => {
  const { t } = useTranslation();
  const img =
    app.technology === "stripe"
      ? stripeLogo
      : app.technology === "shopify"
        ? shopifyLogo
        : app.technology === "mirrorstatus"
          ? mirrorImg
          : null;

  // Map app IDs to translation keys
  const getTranslationKey = (id) => {
    const keyMap = {
      1: "notifySync",
      2: "invoiceEditor",
      3: "syncToSheets",
      4: "reviewHub",
      5: "checkoutChaser",
      6: "mirrorstatus",
    };
    return keyMap[id] || "";
  };

  const translationKey = getTranslationKey(app.id);

  return (
    <div className="app-card">
      {/* Logo */}
      <div className="flex w-full justify-between">
        <h3 className="text-[20px] md:text-[30px] font-normal">
          {t(`shopifyStripe.content.apps.${translationKey}.name`)}
        </h3>
        <img src={img} className="h-full" alt={`${app.technology} Logo`} />
      </div>

      {/* Content */}
      <div className="w-full">
        <p className="text-[12px] md:text-[16px]">
          {t(`shopifyStripe.content.apps.${translationKey}.description`)}
        </p>
      </div>
    </div>
  );
};

const ShopifyContent = () => {
  const { t } = useTranslation();

  return (
    <div className="shopify-content">
      {/* Cards Section */}
      <div className="cards-section">
        <h1 className="text-[26px] md:text-[30px] text-center !font-normal">
          Our Power-Packed App Portfolio!
        </h1>
        <div className="cards-grid">
          {cardData.map((app) => (
            <div key={app.id} className="card-wrapper">
              <AppCard app={app} />
            </div>
          ))}
        </div>
      </div>

      <div className="md:flex md:!p-[2rem] text-center md:text-left !px-5 md:!px-32">
        <div className="md:flex-1">
          <h3 className="text-[26px] md:text-[30px] font-semibold">
            {t("shopifyStripe.content.overview.title")}
          </h3>
        </div>
        <div className="md:flex-1">
          <h3 className="text-[20px] md:text-[22px] !mt-5 md:!mt-0 !mb-2 md:!mb-5 font-medium">
            {t("shopifyStripe.content.overview.subtitle")}
          </h3>
          <p className="text-[12px] md:text-[16px]">
            {t("shopifyStripe.content.overview.description")}
          </p>
        </div>
      </div>
    </div>
  );
};

export default ShopifyContent;
